import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { SITE_URL, buildTitle } from '../utils/seo';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>{buildTitle('Page Not Found')}</title>
        <meta
          name="description"
          content="The page you requested could not be found."
        />
        <meta name="robots" content="noindex,follow" />
        <meta name="googlebot" content="noindex,follow" />
        <link rel="canonical" href={`${SITE_URL}/`} />
      </Helmet>
      <main className="max-w-4xl mx-auto px-6 py-16 text-center">
        <p className="text-xs uppercase tracking-[0.35em] text-[#7b7671]">404</p>
        <h1 className="font-display text-4xl md:text-5xl mt-4 text-[#1c1b1a]">Page Not Found</h1>
        <p className="text-[#6a6661] mt-4">
          The URL may be outdated or incorrect.
        </p>
        <Link
          to="/"
          className="inline-block mt-8 px-8 py-3 bg-[#2d2b29] text-[#f5f4f2] text-xs uppercase tracking-[0.25em] hover:bg-[#1f1d1b] transition-colors"
        >
          Go Home
        </Link>
      </main>
    </>
  );
}
